import { Stack, Typography, useTheme } from "@mui/material";
import { ChevronRight, type LucideIcon } from "lucide-react";
import type { FC } from "react";
import { IconBox } from "web_myplann/Shared/Components/IconBox";
import type { CalloutAppearance } from "web_myplann/Shared/Types/CalloutAppearance";

type Props = {
	appearance: CalloutAppearance;
	icon: LucideIcon;
	title: string;
	description: string;
	showChevron: boolean;
};

export const CalloutContent: FC<Props> = ({
	appearance: { content, iconBox, icon, chevron },
	icon: Icon,
	title,
	description,
	showChevron,
}) => {
	const { palette, spacingTokens } = useTheme();

	return (
		<Stack
			direction="row"
			alignItems={content.alignItems}
			gap={spacingTokens.md}
			p={content.padding}
		>
			<IconBox bg={iconBox.bg} size={iconBox.size}>
				<Icon size={icon.size} color={icon.color} />
			</IconBox>
			<Stack flex={1} minWidth={0} gap={0.2}>
				<Typography variant="bodyStrong">{title}</Typography>
				<Typography variant="caption" color={palette.grey[600]} relaxed>
					{description}
				</Typography>
			</Stack>
			{showChevron && (
				<ChevronRight size={chevron.size} color={chevron.color} />
			)}
		</Stack>
	);
};
